import React from "react";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import styles from "./StageAssistant.module.scss";
import Select from "../../../../../ui/Select/Select";
import MultiSelect from "../../../../../ui/MultiSelect/MultiSelect";
import Button from "../../../../../ui/Button/Button";
import { TrashIcon } from "../../../../../assets/icons/TrashIcon";
import { ClipLoader } from "react-spinners";

export const StageAssistant = ({
  selectObserverAssistantForStage,
  stageAssistantName,
  initDialog,
  item,
  dataAssistants,
  handleInitDialogChange,
  messageInstructions,
  handleMessageInstructionChange,
  combinedDataMessengers,
  stageMessengerUsers,
  handleChange,
  getUserDisplayName,
  getUserUniqueId,
  getUserDetails,
  getUserSearchValues,
  stageAssistants,
  handleSendDataEditAssistant,
  cancelChanges,
  removeAssistantFromStage,
  loading,
}) => {
  return (
    <div className={styles.stageAssistantWrapper}>
      <div className={styles.stageAssistantContainer}>
        <div style={{ width: "100%" }}>
          <Select
            containerStyle={styles.select}
            dataSelect={dataAssistants}
            title="Ассистент"
            selectObserver={(val) =>
              selectObserverAssistantForStage(item.id, val)
            }
            nameSelectedOption={stageAssistantName}
          />
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => removeAssistantFromStage(item.id)}
        >
          <TrashIcon width={15} height={18} fill={"red"} />
        </div>
      </div>
      <div className={styles.initDialogContainer}>
        <Checkbox
          id={item.id}
          value={initDialog[item.id] || false}
          onChange={handleInitDialogChange(item.id)}
          title="Может писать первым"
        />
        {initDialog[item.id] && (
          <div className={styles.infoContainer}>
            <textarea
              cols="30"
              rows="10"
              placeholder="Инструкция для сообщения клиенту"
              value={messageInstructions[item.id] || ""}
              onChange={handleMessageInstructionChange(item.id)}
              className={styles.textarea}
            >
              hello
            </textarea>
            <div className={styles.integrationContainer}>
              <div className={styles.titleIntegration}>
                Выберите интеграцию:
              </div>
              <MultiSelect
                data={combinedDataMessengers}
                selectedItems={stageMessengerUsers}
                onChange={handleChange(item.id)}
                getDisplayValue={getUserDisplayName}
                getUniqueId={getUserUniqueId}
                getItemDetails={getUserDetails}
                getSearchValues={getUserSearchValues}
                placeholder="Выберите интеграции..."
                searchPlaceholder="Искать интеграцию..."
                noResultsText="Интеграции не найдены"
                clearSelectionText="Снять выделение"
                resultsFoundText="Интегрций найдено"
              />
            </div>
          </div>
        )}
        {stageAssistants[item.id]?.editMode && (
          <div className={styles.stagesBtnContainer}>
            <Button
              className={styles.stageBtn}
              titleClassName={styles.stageBtnTitle}
              leftIcon={loading && <ClipLoader color="white" size={12} />}
              title={loading ? "Подождите" : "Сохранить"}
              onClick={() =>
                handleSendDataEditAssistant(
                  item,
                  stageAssistants[item.id]?.assistantId
                )
              }
            />
            <Button
              className={styles.stageBtnCancel}
              titleClassName={styles.stageBtnTitleCancel}
              title="Отмена"
              onClick={() => cancelChanges(item.id)}
            />
          </div>
        )}
      </div>
    </div>
  );
};
